import React, { useEffect, useState }  from 'react';
import { CsvButton,downloadCSV } from '../../../service/CsvButton';
import { ReactTableServerSide } from '../../ReactTableServerSide';
import ViewError from '../components/ViewError';
import auth from '../../../service/Auth';
import {get_qc_metrics} from '../../../service/apis';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {GPAP_Button_light} from "../../../../gpap-lib/Button_Collection";
import Typography from '@mui/material/Typography';
import CustomizeColumns from "../components/CustomizeColumns";
import { header_qc_metrics_config, qc_metrics_search_delayed, aggr_keys_qc_metrics} from "../components/headers_config";
import settings from '../../../DataManagementConfig';


const config = window.config;


const QcMetrics = () => {

    const [headers, setHeaders] = useState(header_qc_metrics_config);
    const [qcMetrics, setQcMetrics] = useState([]);
    const [pagination, setPagination] = useState({});
    const [errors, setErrors ] = useState("");
    const [loadData, setLoadData] = useState(true);
    const [tableColumns, setTableColumns ] = useState([]);
    const [aggregations, setAggregations ] = useState({});
    const [headersTable, setHeadersTable] = useState([]);
    const [rowsTable, setRowsTable] = useState([]);
    const [columnMinWidth, setColumnMinWidth] = useState(120);
      
    useEffect(() => {
        if (auth.tokenExpired()) {
            // Logging check
            setErrors("Logging session timeout. Please log again");
        }
        else {
            //Initialize Pagination 
            setPagination({
                page: 0, pages: 0, pageSize: 100,
                totalItems: 0,
                fields: [], filtered: [], sorted: []
            });
        }
    },[])
    
    const loadTableData = (state,instance) => {
        // Method to call API Endpoint to get React Table Data
        setLoadData(true);    
        // Get fields to be requiered
        let fields = [];
        for (let header of headers) {
            fields.push(header.key);
        }
        // Call API Endpoint
        let data_query = {
            "page" : (state.page + 1),
            "pageSize" : state.pageSize,
            "fields" : fields,
            "aggregates": aggr_keys_qc_metrics
        }
        // Check filtered Criteria
        if (state.filtered) {
            data_query["filtered"] = state.filtered.map( item => ( { id:item.id, value:[item.value]} ) );
        }
        // Check sorted Criteria
        if (state.sorted) {
            data_query["sorted"] = state.sorted;
        }
        // Call POST Data
        get_qc_metrics(auth.getToken(),config.api_endpoint, JSON.stringify(data_query))
        .then((response) => {
            return response.json()
        })
        .then((data) => {
            let aggregations = {};
            if (data["_meta"]["total_items"] > 0) aggregations = data._meta.aggregates;
            setQcMetrics(data["items"]);
            setPagination({
                page : data["_meta"]["page"],
                pages : data["_meta"]["total_pages"],
                pageSize : data["_meta"]["page_size"],
                totalItems : data["_meta"]["total_items"],
                fields :fields, filtered : state.filtered,
                sorted : state.sorted
            });
            setAggregations(aggregations);
            setLoadData(false);
        })
    };

    const updateColumns = (columns) => {
        // Update custom columns
        let stateHeaders = [];
        for (let field of columns) {
            stateHeaders.push(header_qc_metrics_config.find(item => item.key === field));
        } 
        setTableColumns(columns);
        setHeaders(stateHeaders);
    }

    const getTableHeaders = () => {
        // Get Table Columns
        let columns = [];
        for (let header of headers) {
            let column = {};
            if ("tooltip" in header){
                column["Header"] =  props => <span title={header.tooltip}>{header.label} <i className="fa fa-comment-o" aria-hidden="true"></i></span>;
            }
            else{
                column["Header"] = header.label;
            }
            column["accessor"] = header.key;
            column["minWidth"] = columnMinWidth;
            // Choices for headers queried on the aggregates
            if(aggr_keys_qc_metrics.includes(header.key) &&  Object.keys(aggregations).length > 0)
            {               
                let values = aggregations[header.key];
                let aggregates = (values !== undefined && values !== null) ? Object.keys(values[0]) : [];
                column["Filter"] = ({ filter, onChange }) => <select
                        onChange={event => onChange(event.target.value)}
                        style={{ width: "100%" }}
                        value={filter ? filter.value : "all"}
                      >
                      <option value="">Show All</option>
                        {aggregates.sort().map(function(opt){
                            return <option value={opt}>{opt}</option>
                        })}
                    </select>;
                column["filter"] = 'equal';
            }
            columns.push(column);
        }
        // Filter visible columns
        const allColumns = (tableColumns.length!==0) ? columns.filter(s => tableColumns.includes(s.accessor)) : columns;
        setHeadersTable(allColumns);
    }
    
    const getDataTable = () => {
        // Build data to render on react-table
        let data = [];
        for (let metrics of qcMetrics){
            let row = {};
            // 1. Loop Headers
            for (let column of headersTable){
                if (typeof metrics[column.accessor] === "boolean") row[column.accessor] = metrics[column.accessor].toString();
                else row[column.accessor] = metrics[column.accessor];
            }
            // 2. Add row to data
            data.push(row);
        }
        setRowsTable(data);
    }
    
    useEffect(() => {
        // Set headers
        getTableHeaders();
    },[qcMetrics,aggregations,tableColumns])

    useEffect(() => {
        // Set rows
        getDataTable();
    },[headersTable])
    
    const closeModal = () => {
        setErrors("");
    }
    
    const getCsvData = async (headers) => {
        // Trigger Load Process
        setLoadData(true);
        // Get All Data to be printed to CSV Files 
        let data_query = {
            "page" : 1,
            "pageSize" : settings.apiFilesCSVPageSize,
            "fields" : pagination.fields,
            "filtered" : pagination.filtered.map( item => ( { id:item.id, value:[item.value]} ) ),
            "sorted": pagination.sorted
        }
        let getData = true;
        let allItems = []
        // Get All Data
        while (getData){
              // Call POST Data
              await get_qc_metrics(auth.getToken(),config.api_endpoint, JSON.stringify(data_query))
              .then((response) => {
                  return response.json()
              })
              .then((data) => {
                  allItems.push(...data["items"]);
                  if (data_query.page < data["_meta"]["total_pages"]){
                        getData = true;
                        data_query.page = data_query.page + 1;
                  }
                  else getData = false;
              })
        }
        // Build data for CSV
        let data = [];
        for (let item of allItems){
            let row = {};
            //1. Loop Headers
            for (let header of headers) {
                  if (typeof item[header.key] === "boolean") row[header.key] = item[header.key].toString();
                  else row[header.key] = item[header.key];
            }
            //2. Add row to data
            data.push(row);
        }
        // Call CSV File
        let today = new Date().toISOString().slice(0, 10);
        downloadCSV(data,headers,`${today}_qc_metrics.csv`);
        setLoadData(false);
    }
    
    if (errors !== "") {
        // Show ViewError in case an error with the loggin occurs
        return <ViewError closeModal={closeModal} title={"Logging Error"} message={errors}/>;
    }
    else {
        return (
            <div className={"mainContent"}>
                <Typography variant={"h5"} align={"center"}> Experiments QC Metrics </Typography>
                <GPAP_Button_light href = "#/management"  startIcon={<ArrowBackIcon />}>
                    Back
                </GPAP_Button_light>
                <CsvButton getCsvData={getCsvData} />
                <CustomizeColumns
                    type = {"metrics"}
                    updateColumns = {updateColumns}
                />
                <ReactTableServerSide
                    headers={headers}
                    columns={headersTable}
                    data={rowsTable}
                    pagination={ pagination }
                    loadTableData={loadTableData}
                    fieldsDelay={qc_metrics_search_delayed}
                    loading={loadData}
                />
            </div>
        );
    }
}

export default QcMetrics;